module.exports = __webpack_public_path__ + "f62e9e104b98af6d3c443c6673d9b2fa.svg";